export default __webpack_public_path__ + "static/media/um.c6387424.svg";